import React from 'react'
import CompletionSummary from 'steps/spot-the-diff/components/CompletionSummary'

export const EndGameModal = ({
  open,
  onClose,
  center,
  isWin,
  ...otherProps
}) => {
  return open ? (
    <div
      className="modal__wrapper"
      style={{
        ...(center && {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }),
      }}
    >
      <CompletionSummary isWin={isWin} onClose={onClose} {...otherProps} />
    </div>
  ) : (
    <></>
  )
}
